import { Component, input } from '@angular/core';
import { TextSegment } from '../../core/error-text';

//
// A text of which the web addresses are links; see splitWebAddresses. No whitespace between the parts: they
// are pieces of one sentence, and a space around a part would show before a full stop.
//
@Component({
  selector: 'app-linked-text',
  standalone: true,
  template: '@for (part of parts(); track $index) {@if (part.url) {<a [href]="part.url" target="_blank" rel="noopener noreferrer">{{ part.text }}</a>} @else {<span>{{ part.text }}</span>}}',
})
export class LinkedTextComponent
{
  readonly parts = input.required<TextSegment[]>();
}
